// extracted by mini-css-extract-plugin
export default {"Actions":"GlobalActions_Actions__8pR4W","ActionButton":"GlobalActions_ActionButton__MuSdH","Badge":"GlobalActions_Badge__tfWuC","LanguageFlag":"GlobalActions_LanguageFlag__wDigj"};